import { mergeDeep } from 'heliocor-ui'
import { translateChecker } from './translateChecker';

const extractSummaryDetails = (fieldsDetail = {}, instructedObject, partyType) => {

    const summaryDetails = [...instructedObject[partyType]]

    Object.entries(fieldsDetail).forEach(([category, fields]) => {
        let details = { titleId: category, fields: [], labels: {} }
        fields.forEach(field => {
            details.fields.push(field.id)
            details.labels[field.id] = field.customLabel || translateChecker(field.id)
        })
        summaryDetails.push(details)
    });
    return {[partyType]: summaryDetails}
}


const getSummaryDetails = ({
    isSummary,
    customFields,
    prevDetails,
    partyType,
    isRequest
}) => {
    let dataToVisualize = {} 
    const INITIAL_DETAILS = { PERSON: [], COMPANY: [], CONNECTED_PERSON: [], CONNECTED_COMPANY: [] }
    const DOCUMENTS_DETAIL = { titleId: 'DOCUMENTS' }
    const summaryFieldsDetails = extractSummaryDetails(customFields, INITIAL_DETAILS, partyType)

    if (isRequest) {
        const summaryRequestDetails = extractSummaryDetails(prevDetails, INITIAL_DETAILS, partyType)
        if(isSummary){  
            dataToVisualize[partyType] = mergeDeep(summaryRequestDetails[partyType], summaryFieldsDetails[partyType])
        } else {
            dataToVisualize = summaryRequestDetails
        }
    } else {
        dataToVisualize = summaryFieldsDetails
    }

    dataToVisualize[partyType].push(DOCUMENTS_DETAIL)
    partyType === 'COMPANY' && dataToVisualize[partyType].push({titleId: 'STRUCTURE'})

    return dataToVisualize
}

const getFieldsInformation = (rawFields) => {
    const fieldsInfo = {}
    Object.values(rawFields)
        .flat()
        .forEach(({ id, type, currency, customOptions }) => fieldsInfo[id] = { type, currency, customOptions })
    return fieldsInfo
}

export { getSummaryDetails, getFieldsInformation }